import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import VeiculoCard from './components/VeiculoCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const VeiculosMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Inicio' },
            { name: 'Veiculos' },
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <VeiculoCard />
      </Col>
    </Row>
  </Container>
);

export default VeiculosMain;